/**
 * @prettier
 */
import {
    defineComponents,
    DocumentReaderService,
    DocumentReaderProcessor,
} from '@regulaforensics/vp-frontend-document-components';

// Config
import * as regulaConfig from '../../config/regula';

// Services
import DataDogService from './datadogService';

/**
 * Initialize Document Reader SDK
 */
export function initialize() {
    DataDogService.log('Initializing Regula Capture SDK');
    window.RegulaDocumentSDK = new DocumentReaderService();

    window.RegulaDocumentSDK.recognizerProcessParam =
        regulaConfig.recognizerProcessParam;
    window.RegulaDocumentSDK.imageProcessParam = regulaConfig.imageProcessParam;

    if (process.env.REACT_APP_REGULA_DEV_TOKEN !== '') {
        DataDogService.log('Using Regula Dev Token');
        // Using Dev Token
        defineComponents().then(() =>
            window.RegulaDocumentSDK.initialize({
                license: process.env.REACT_APP_REGULA_DEV_TOKEN,
            })
        );
    } else {
        DataDogService.log('Using Regula Domain License');
        defineComponents().then(() => window.RegulaDocumentSDK.initialize());
    }
}

/**
 * Initialize Native Capture with Advanced Regula SDK
 */
export async function initalizeNativeCapture(image, callback) {
    DataDogService.log('Initializing Regula Document Processor');
    window.RegulaProcessor = new DocumentReaderProcessor();
    window.RegulaProcessor.recognizerProcessParam =
        regulaConfig.recognizerProcessParam;
    window.RegulaProcessor.imageProcessParam = regulaConfig.imageProcessParam;

    if (process.env.REACT_APP_REGULA_DEV_TOKEN !== '') {
        DataDogService.log('Using Regula Dev Token');
        await window.RegulaProcessor.initialize({
            license: process.env.REACT_APP_REGULA_DEV_TOKEN,
        });
    } else {
        DataDogService.log('Using Regula Domain License');
        await window.RegulaProcessor.initialize();
    }
    let result = await window.RegulaProcessor.processImage(image);
    callback(result);
}

/**
 * Extracting image from Regula response
 */
export function findImage(response, cropped) {
    DataDogService.log('Finding image in Regula Response');
    for (const field of response.images.fieldList) {
        if (field.fieldName === regulaConfig.fieldNames.front) {
            for (const image of field.valueList) {
                if (
                    image.containerType ===
                        regulaConfig.containerTypes[
                            cropped ? 'cropped' : 'uncropped'
                        ] &&
                    image.pageIndex === 0
                ) {
                    return 'data:image/jpeg;base64,' + image.value;
                }
            }
        }
    }
}

export function getImageSize(response) {}

export function getTag(response) {
    return response.TransactionInfo.Tag;
}
